import {
  buildClientDevice,
  publishOrtb2,
  publisherDomain,
  toOrtb2,
} from '@redbrickmedia/duplex.user-identity'
import debug from '../utils/console'

const logger = debug.withTag('plugins:ortb-fpd')

export default defineNuxtPlugin({
  name: 'ortb-fpd',
  dependsOn: ['assertive'],
  setup: () => {
    const { $filters } = useNuxtApp()
    const domain = publisherDomain()
    if (!domain) {
      return
    }

    const { siteName } = useRuntimeConfig().public
    const name = typeof siteName === 'string' && siteName ? siteName : domain

    const publish = (articleId: string | null) => {
      try {
        const ortb2 = toOrtb2(
          { geo: $filters, device: buildClientDevice() },
          { domain, name, page: window.location.href },
          articleId ? { id: articleId } : undefined
        )

        // AY applies its Prebid config once on load; the queue drains after.
        window.assertiveQueue = window.assertiveQueue || []
        window.assertiveQueue.push(() => publishOrtb2(ortb2))
      } catch (error) {
        // Ads must load whether or not first-party data does.
        logger.warn('Failed to publish ORTB first-party data', error)
      }
    }

    const articleId = (route: { params: Record<string, unknown> }) => {
      const id = route.params.id
      return (Array.isArray(id) ? id[0] : id) ?? null
    }

    publish(articleId(useRoute()))

    // Articles arrive by client-side navigation. publishOrtb2 replaces
    // site.content rather than appending.
    useRouter().afterEach((to) => publish(articleId(to)))
  },
})
